const ITEMS = [
  "HEAVYWEIGHT COTTON",
  "EMBROIDERED DAD HATS",
  "SCREENPRINTED TOUR POSTERS",
  "ECO-FRIENDLY TOTE BAGS",
  "DIRECT TO VENUE SHIPPING",
  "NO OVERSEAS CARGO FEES",
  "FAST LOCAL FULFILLMENT",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-zinc-200 bg-tour-zinc py-5">
      <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10 font-mono text-xs uppercase tracking-[0.3em] text-zinc-500">
            {item}
            <span className="h-1 w-1 rounded-full bg-tour-red" />
          </span>
        ))}
      </div>
    </div>
  );
}
